import intl from 'react-intl-universal';
import OtpInput from 'react-otp-input';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';

import InsNavLink from 'shared/components/ins-nav-link/InsNavLink';

import styles from './mfaOtpForm.module.scss';
import MfaOtpFormProps from './MfaOtpFormProps';

const MfaOtpForm: React.FC<MfaOtpFormProps> = (props: MfaOtpFormProps) => {
  const {
    otp,
    trustDevice,
    onTryOtherOptions,
    onOtpVerification,
    onOtpChange,
    onTrustDeviceChange,
  } = props;

  return (
    <>
      <p className="text-16-bold">{intl.get('LBL_MFA_OTP_SUB_TITLE')}</p>
      <p className="text-14-light mb-4">
        {intl.get('LBL_MFA_OTP_DESCRIPTION')}
      </p>
      <FormGroup>
        <Label>{intl.get('LBL_MFA_OTP_INPUT_LABEL')}</Label>
        <OtpInput
          value={otp}
          onChange={onOtpChange}
          numInputs={6}
          // Set inputType to tel to avoid arrow buttons
          inputType="tel"
          containerStyle={styles.otpContainer}
          inputStyle={styles.otpInput}
          shouldAutoFocus
          // eslint-disable-next-line react/jsx-props-no-spreading
          renderInput={(inputProps) => <input {...inputProps} />}
        />
      </FormGroup>

      <div className="insight-checkbox-group">
        <Label>
          <Row>
            <Col xs={1}>
              <span className="insight-checkbox mr-3 mt-1" data-cy="terms-cb">
                <input
                  type="checkbox"
                  name="trustDevice"
                  checked={trustDevice}
                  onChange={(e) => onTrustDeviceChange(e.target.checked)}
                />
                <i className="icon-check" />
              </span>
            </Col>
            <Col>
              <p className="text-14-semibold color-secondary-dark mb-0">
                {intl.get('LBL_MFA_TRUST_DEVICE_LABEL')}
              </p>
              <p className="text-14-light mb-0">
                {intl.get('LBL_MFA_TRUST_DEVICE_SUB_LABEL')}
              </p>
            </Col>
          </Row>
        </Label>
      </div>

      <Button
        size="lg"
        color="primary"
        className="w-100 justify-content-center mt-4 mb-5"
        onClick={onOtpVerification}
      >
        {intl.get('BTN_AUTHENTICATE')}
      </Button>

      <Row>
        <Col className="text-14-medium text-center">
          {intl.get('LBL_MFA_OTP_FOOTER_LABEL')}
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <InsNavLink to="" onClick={onTryOtherOptions}>
            <span className="text-14-light text-secondary-dark">
              {intl.get('LBL_MFA_OTP_FOOTER_LINK')}
            </span>
          </InsNavLink>
        </Col>
      </Row>
    </>
  );
};

export default MfaOtpForm;
